import * as React from 'react'

import { Box, Button, Checkbox } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteCandidate } from './useDeleteCandidate'

interface Props {
  candidateId: number
  onClose: () => void
}

export const DeleteCandidateModal = ({ candidateId, onClose }: Props) => {
  const { deleteCandidate, loading: deleting } = useDeleteCandidate(candidateId)
  const [agreeCheckbox, setAgreeCheckbox] = React.useState(false)

  const onSubmit = async () => {
    const result = handleResult(await deleteCandidate(), () => undefined)

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ats.candidates.delete_modal.error_message'),
      })
    }

    onClose()
  }

  return (
    <Modal
      illustration="delete"
      title={i18n.t('ats.candidates.delete_modal.title')}
      description={i18n.t('ats.candidates.delete_modal.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Box flexDirection="row" justifyContent="flexEnd" gap="s8">
          <Button type="secondary" disabled={deleting} onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>

          <Button type="negative" disabled={deleting || !agreeCheckbox} submit>
            {i18n.t('ats.candidates.delete_modal.submit')}
          </Button>
        </Box>
      }
    >
      <Checkbox
        checked={agreeCheckbox}
        label={i18n.t('ats.candidates.delete_modal.checkbox_label')}
        onChange={(event) => setAgreeCheckbox(event.target.checked)}
      />
    </Modal>
  )
}
